// // src/components/common/ShowButton.jsx
// import React from "react";
// import Button from "@mui/material/Button";

// const ShowButton = ({ onClick, disabled = false, children = "Show" }) => {
//   const getColorVar = (name) =>
//     getComputedStyle(document.documentElement).getPropertyValue(name).trim();

//   const blue = getColorVar('--azure-500');
//   const white = getColorVar('--white');
//   const gray = getColorVar('--slate-gray');
//   const border = getColorVar('--white-100');

//   return (
//     <Button
//       variant="contained"
//       onClick={onClick}
//       disabled={disabled}
//       sx={{
//         backgroundColor: blue,
//         color: white,
//         fontSize: "12px",
//         padding: "6px 16px",
//         borderRadius: "8px",
//         textTransform: "none",
//         fontFamily: "'Public Sans', sans-serif",
//         height: "30px",
//         lineHeight: "0.25px !important",
//         "&:hover": {
//           backgroundColor: blue,
//         },
//         "&.Mui-disabled": {
//           backgroundColor: border,
//           color: gray,
//         },
//       }}
//     >
//       {children}
//     </Button>
//   );
// };

// export default ShowButton;


// src/components/common/ShowButton.jsx
import React from "react";
import Button from "@mui/material/Button";

const ShowButton = ({
  onClick,
  disabled = false,
  children = "Show",
  className = "",
}) => {

  // Modern color palette (Material Design)
  const blue = '#6C8EBF';
  const white = '#ffffff';
  const gray = '#9e9e9e';
  const border = '#e0e0e0';


  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      className={className} // ✅ Allow custom class for positioning
      sx={{
        backgroundColor: blue,
        color: white,
        fontSize: "12px",
        padding: "6px 16px",
        borderRadius: "8px",
        textTransform: "none",
        fontFamily: "'Public Sans', sans-serif",
        height: "30px",
        width: "68px",
        "&:hover": {
          backgroundColor: blue,
        },
        "&.Mui-disabled": {
          backgroundColor: border,
          color: gray,
        },
      }}
    >
      {children}
    </Button>
  );
};

export default ShowButton;
